import angular from 'angular';
import $ from 'jquery';
import template from './template.html';
import './style.scss';
import {
    summernoteOptions,
    VIEW_STATE,
    EDIT_STATE,
} from '../../../summernote-options';

export class MessageTextArea {
    /* @ngInject */
    constructor($timeout) {
        this.$timeout = $timeout;
    }

    message = '';

    internalMessage = '';

    originalMessage = '';

    textareaState = VIEW_STATE;

    summernotes = [];

    summernoteOptions = {
        ...summernoteOptions,
        callbacks: {
            onInit: (summernote) => {
                this.summernotes.push(summernote);

                const { toolbar, editable } = summernote;
                const $win = $(window);
                const $noteEditor = $('.note-editor');

                toolbar.hide();
                $win.on('click.Bst', (event) => {
                    if ($noteEditor.has(event.target).length === 0 && !$noteEditor.is(event.target)) {
                        toolbar.hide();
                    }
                });
                editable.focus(() => toolbar.show());

                this.setState(VIEW_STATE);
            },
        },
    };

    $onChanges({ textareaState }) {
        this.internalMessage = angular.copy(this.message);
        this.originalMessage = angular.copy(this.internalMessage);

        if (textareaState) {
            this.setState(textareaState.currentValue);
        }
    }

    onEditMessage() {
        this.setState(EDIT_STATE);
    }

    onSaveMessage() {
        this.onMessageChange({ message: this.internalMessage });
        this.setState(VIEW_STATE);
    }

    onCancelEditMessage() {
        this.internalMessage = angular.copy(this.originalMessage);

        this.setState(VIEW_STATE);
    }

    setState(state) {
        const summernoteEditableState = state === EDIT_STATE;

        this.setSummernoteEditableState(summernoteEditableState);
        this.textareaState = state;
        this.onEditStateChange({ state });
    }

    setSummernoteEditableState(state) {
        (this.summernotes || []).forEach(summernote => {
            const { editable } = summernote;

            if (editable) {
                $(editable)
                    .prop('contenteditable', state);
            }
        });
    }
}

export const messageTextAreaConfiguration = {
    template,
    bindings: {
        message: '<',
        textareaState: '<',
        onMessageChange: '&',
        onEditStateChange: '&',
    },
    controller: MessageTextArea,
    controllerAs: 'messageTextAreaCtrl',
};

angular
    .module('TALENYA-FE')
    .component('messageTextarea', messageTextAreaConfiguration);
